import type { ReactNode } from "react";

export type ProfileVerifyActionPillProps = Readonly<{
  disabled?: boolean;
  icon: ReactNode;
  label: string;
  onClick?: () => void;
  title?: string;
}>;

export function ProfileVerifyActionPill({
  disabled,
  icon,
  label,
  onClick,
  title,
}: ProfileVerifyActionPillProps) {
  return (
    <button
      type="button"
      className="profile-verify-action-pill"
      disabled={disabled || !onClick}
      onClick={onClick}
      title={title}
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}
